<template>
    <loadtem v-if="proloading" :progress="progress" :point="point"></loadtem>
    <ScaleScreen :width="1920" :height="1080" class="scale-wrap" v-else>
        <!-- <ScaleScreen :width="1920" :height="1080" class="scale-wrap"> -->
        <div class="template4">
            <div class="box-bg">
                <homehead title="企业销售数据可视化平台" class="head_animation"></homehead>
                <div class="tem-content">
                    <div class="left-content">
                        <textTitle title="人群消费占比" class="left_animation_1"></textTitle>
                        <leftTop class="left_animation_1"></leftTop>
                        <textTitle title="月度销售额" class="left_animation_2"></textTitle>
                        <leftCent class="left_animation_2"></leftCent>
                        <textTitle title="商品销售金额" class="left_animation_3"></textTitle>
                        <leftBottom class="left_animation_3"></leftBottom>
                    </div>
                    <div class="center-content">
                        <centerTop :vdata="{}" class="center_animation_1"></centerTop>
                    </div>
                    <div class="right-content">
                        <textTitle title="人群消费占比" class="right_animation_1"></textTitle>
                        <rightTop class="right_animation_1"></rightTop>
                        <textTitle title="应收款项目" class="right_animation_2"></textTitle>
                        <rightCent class="right_animation_2"></rightCent>
                        <textTitle title="各季度增长情况" class="right_animation_3"></textTitle>
                        <rightBottom class="right_animation_3"></rightBottom>
                    </div>
                </div>
                <homebottom class="bottom_animation"></homebottom>
            </div>
        </div>
    </ScaleScreen>
</template>

<script>
import homehead from "../../components/template4/temhead4.vue";
import ScaleScreen from "../../components/scale-screen/scale-screen.vue";
import homebottom from "../../components/template4/homebottom4.vue";
import leftTop from "../../components/template4/leftTop4.vue";
import leftCent from "../../components/template4/leftCent4.vue";
import leftBottom from "../../components/template4/leftBottom4.vue";
import centerTop from "../../components/template4/centerTop4.vue";
import rightTop from "../../components/template4/rightTop4.vue";
import rightCent from "../../components/template4/rightCent4.vue";
import rightBottom from "../../components/template4/rightBottom4.vue";
import textTitle from "../../components/template4/textTitle4.vue";
import loadtem from '../../components/porloading.vue'
import { preloadResources } from "@/utils/loading";

export default {
    components: {
        ScaleScreen,
        homehead,
        homebottom,
        leftTop,
        leftCent,
        leftBottom,
        centerTop,
        rightTop,
        rightCent,
        rightBottom,
        textTitle,
        loadtem,
    },
    data() {
        return {
            titleArr: ['经营情况', '消费人群分析', '各个省份实时销售额排行', '线上线下销售额占比', '门店销售排名', '时段销售趋势'],
            proloading: true,
            point: '.',
            time1: null,
            progress: 0
        };
    },
    async created() {
        const resourceList = [
            require("@/assets/template4/bg.png"),
            require("@/assets/template4/bottom.png"),
            require("@/assets/template4/control.png"),
            require("@/assets/template4/header.png"),
            require("@/assets/template4/title.png"),

            // require("@/assets/template4/lt1.png"),
            // require("@/assets/template4/lt2.png"),
            // require("@/assets/template4/lt3.png"),
            // require("@/assets/template4/lt4.png"),
            // require("@/assets/template4/num-bg.png"),
        ];
        if (!this.time1) {
            this.time1 = setInterval(() => {
                this.addpoint()
            }, 600)
        }
        this.addpoint()
        await preloadResources(resourceList, this.progressCallback);
        clearInterval(this.time1)
        this.time1 = null
        this.proloading = false
    },
    methods: {
        progressCallback(progress) {
            this.progress = progress * 100
        },
        addpoint() {
            if (this.point !== '...') {
                this.point += '.'
            } else {
                this.point = ''
            }
        }
    }
};
</script>
<style scoped lang="scss">
.template4 {
    width: 100%;
    height: 100%;
    display: block;
    position: relative;
    z-index: 401;

    .box-bg {
        position: relative;
        background: url('../../assets/template4/bg.png') no-repeat;
        background-size: 100% 100%;
        pointer-events: none;
        z-index: 400;
    }

    .tem-content {
        margin-top: -30px;
        height: 890px;
        width: 100%;
        display: flex;
        // pointer-events: none;
        pointer-events: auto;
    }

    .left-content,
    .right-content {
        width: 475px;
        position: relative;
        z-index: 401;
        pointer-events: auto;
    }

    .left-content {
        padding: 0 0 0 40px;
    }

    .right-content {
        padding: 0 40px 0 0;
        box-sizing: border-box;
    }

    .center-content {
        pointer-events: auto;
        width: 980px;
        // background: #ffffff;
        position: relative;
        z-index: 401;
    }
}
</style>